import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router';
import { THEME } from '../../../components-v2/Theme/theme';

const useIsCompactNav = ({ compactNavPaths }: { compactNavPaths: { exact?: boolean; path: string }[] }) => {
	const isMobile = useMediaQuery({ maxWidth: THEME.breakpoints.md });
	const { location } = useHistory();
	const currentPath = (location.pathname ?? '').toLowerCase();
	const isCompactPath = !!compactNavPaths.find(x =>
		x.exact ? x.path.toLowerCase() === currentPath : new RegExp(`^${x.path}`, 'i').test(currentPath)
	);
	return isMobile || isCompactPath;
};

const MainCompactNavPaths: { exact?: boolean; path: string }[] = [
	{
		exact: false,
		path: '/dataBoards',
	},
	{
		exact: false,
		path: '/contacts',
	},
	{
		path: '/automations',
	},
	{
		path: '/campaigns',
	},
	{
		path: '/content-calendar',
	},
	{
		path: '/notes-action-items',
	},
	{
		path: '/registration',
	},
	{
		path: '/reporting',
	},
	{
		path: '/texting',
	},
	{
		path: '/settings',
	},
	{
		path: '/surveys',
		exact: false,
	},
	{
		path: '/testimonial-image-editor',
	},
];

export const useIsMainNavCompact = () => {
	return useIsCompactNav({ compactNavPaths: MainCompactNavPaths });
};

const CoffeeCompactNavPaths: { exact?: boolean; path: string }[] = [
	{
		exact: false,
		path: '/people',
	},
	{
		path: '/automations',
	},
	{
		exact: false,
		path: '/companies',
	},
	{
		exact: false,
		path: '/templates',
	},
	{
		exact: false,
		path: '/reporting',
	},
];

export const useIsCoffeeNavCompact = () => {
	return useIsCompactNav({ compactNavPaths: CoffeeCompactNavPaths });
};
